import React from 'react';

import './PregnancyWeek.scss';
import icons from '../../shared/assets/icons';

const { Ruler, Weight } = icons;

export default function PregnancyWeek(props) {
  const babyImage = props.babyImageUrl.match(/href=(.+?)\s/);
  const motherImage = props.motherImageUrl.match(/href=(.+?)\s/);

  return (
    <React.Fragment>
      <section id="pregnancyWeek_baby" className="pregnancyWeek">
        <p className="pregnancyWeek_title">
          Je baby in week {props.weekNr} van je zwangerschap
        </p>

        <div className="pregnancyWeek_content">
          <p className="pregnancyWeek_head">
            In week {props.weekNr} is je baby...
          </p>

          <img src={babyImage && babyImage[1]} alt="week-image" />

          <div className="pregnancyWeek_baby_data">
            <p>
              <Ruler />
              {props.babyLength}
            </p>

            <p>
              <Weight />
              {props.babyWeight}
            </p>
          </div>

          <p className="pregnancyWeek_tail">{props.babyText}</p>
        </div>
      </section>

      <section id="pregnancyWeek_mother" className="pregnancyWeek">
        <p className="pregnancyWeek_title">
          Jij in weekNr {props.weekNr} van je zwangerschap
        </p>

        <div className="pregnancyWeek_content">
          <p className="pregnancyWeek_head">
            In weekNr {props.weekNr} ben jij...
          </p>

          <img src={motherImage && motherImage[1]} alt="week-image" />

          <ul className="pregnancyWeek_mother_data">
            <li>{props.motherDays}</li>

            <li>{props.motherMonth}</li>

            <li>{props.motherTrimester}</li>
          </ul>

          <p className="pregnancyWeek_tail">{props.motherText}</p>
        </div>
      </section>
    </React.Fragment>
  );
}
